import { IFramePlayerEvent } from 'iframe/ts/player/events/IFramePlayerEvent';
import { IFramePlayerErrorCode } from 'iframe/ts/player/model/error/IFramePlayerErrorCode';
import { IFramePlayerErrorFatal } from 'iframe/ts/player/model/error/IFramePlayerErrorFatal';
import { IFramePlayerErrorInfo } from 'iframe/ts/player/model/error/IFramePlayerErrorInfo';
import { MPXMediaType } from 'library/ts/model/enums/mpx/MPXMediaType';
import { SubscriberPackageValue } from 'library/ts/model/user/SubscriberPackageValue';
export const getParamsFromDOM = (parent) => {
    return new Promise((resolve, reject) => {
        const onFailure = (code) => {
            const errorEventVO = {
                type: IFramePlayerEvent.ON_ERROR,
                error: {
                    code: code,
                    fatal: IFramePlayerErrorFatal[code],
                    info: IFramePlayerErrorInfo[code]
                },
                target: parent,
                targetName: parent.name
            };
            parent.dispatchIFramePlayerEvent(errorEventVO);
            reject({ msg: 'Failure to load params from DOM.', success: false, result: errorEventVO });
        };
        if (parent.utils.Type.isFunction(parent?.runtimeVO?.startupCallback)) {
            const paramsVO = parent.runtimeVO.startupCallback();
            parent.logger.log('getParamsFromDOM:', paramsVO);
            if ((parent.utils.Type.isEmpty(paramsVO?.CONTENT?.pid)
                &&
                    parent.utils.Type.isEmpty(paramsVO?.CONTENT?.assetURL))
                ||
                    (!parent.utils.Type.isArray(paramsVO?.CONTENT?.apiMetadata)
                        ||
                            parent.utils.Type.isArray(paramsVO?.CONTENT?.apiMetadata)
                                &&
                                    parent.utils.Type.isEmpty(paramsVO?.CONTENT?.apiMetadata))) {
                onFailure(IFramePlayerErrorCode.P1011);
            }
            else {
                parent.iframePlayer.model.paramsVO = parent.utils.Object.cloneDeep(paramsVO);
                parent.dispatchIFramePlayerEvent({
                    type: IFramePlayerEvent.ON_DOM_READ_PARAMS_SUCCESS,
                    data: {
                        paramsVO: parent.utils.Object.cloneDeep(paramsVO)
                    },
                    target: parent,
                    targetName: parent.name
                });
            }
            resolve({ msg: 'Done.', success: true, paramsVO: paramsVO });
        }
        else {
            onFailure(IFramePlayerErrorCode.P1010);
        }
    });
};
const mediaContentTypeOverride = (apiMetadata) => {
    switch (apiMetadata.isLive) {
        case true:
            return apiMetadata.mediaType;
        case false:
            if (apiMetadata.fullEpisode) {
                return 'vod:fullepisodes';
            }
            else {
                switch (apiMetadata.mediaType) {
                    case MPXMediaType.MOVIE:
                    case MPXMediaType.TRAILER:
                        return 'vod:movies';
                    case MPXMediaType.CLIP:
                        return 'vod:clips';
                }
            }
            break;
    }
    return 'unknown';
};
export const utagDataProcessor = (data) => {
    const utils = window?.IFramePlayer?.utilities;
    const apiMetadata = data?.apiMetadata;
    let utagData = data?.utagData;
    if (utils.Type.isEmpty(apiMetadata) || utils.Type.isEmpty(utagData)) {
        return utagData;
    }
    utagData.isIFrame = true;
    if (data?.scripted === false) {
        const apiToContextMap = [
            { from: ['contentId'], to: 'showEpisodeId' },
            { from: ['episodeNum'], to: 'showEpisodeNumber' },
            { from: ['label', 'title'], to: 'showEpisodeTitle' },
            { from: ['mediaType'], to: 'mediaContentType', override: mediaContentTypeOverride(apiMetadata) },
            {
                from: ['pageType'], to: 'pageType', default: 'article', override: 'article'
            },
            { from: ['seasonNum'], to: 'showSeasonNumber' },
            { from: ['subscriptionLevel'], to: 'mediaSvodContentType' }
        ];
        utagData = utils.Object.mapMerge(apiMetadata, utagData, apiToContextMap);
    }
    return utagData;
};
export const paramsUSER = (data) => {
    const utils = window?.IFramePlayer?.utilities;
    if (data?.scripted === false) {
        const mapFromUtagToUser = [
            { from: ['bundleStatus'], to: 'bundleStatus' },
            { from: ['cp.usprivacy'], to: 'usPrivacy' },
            { from: ['packageSource'], to: 'packageSource' },
            { from: ['userId'], to: 'userId' },
            { from: ['userProfileId'], to: 'profileId' }
        ];
        switch (utils.Type.isEmpty(data?.utagData)) {
            case false:
                data.user = utils.Object.mapMerge(data.utagData, data.user, mapFromUtagToUser);
                break;
            case true:
                break;
        }
    }
    return data.user;
};
export const paramsAD = (data) => {
    const utils = window?.IFramePlayer?.utilities;
    return new Promise((resolve, reject) => {
        if (data.scripted === false) {
            const adParams = {
                FW: {
                    FMS: {
                        fms_userid: '6494b180cad11',
                        fms_vcid2type: 'userid',
                        _fw_vcid2: '6494b180cad11'
                    },
                    GDPR: {
                        _fw_gdpr: 0,
                        _fw_gdpr_consent: null
                    }
                },
                SETTINGS: {
                    ssai: {
                        adParameters: {
                            imafw_sb: SubscriberPackageValue.VALUE_0,
                            imafw_section: 'web-article-page'
                        }
                    }
                }
            };
            data.adParams = utils.DeepMerge.deepmerge(data.adParams, adParams);
        }
        resolve({ msg: 'Ad params ready!', adParams: data.adParams });
    });
};
export const getContextMetadata = (paramsVO, apiMetadata) => {
    const utils = window?.IFramePlayer?.utilities;
    return new Promise((resolve, reject) => {
        let contextMetadata = {};
        const apiToContextMap = [
            { from: ['category'], to: 'category' },
            { from: ['cbsShowId'], to: 'showSeriesId' },
            { from: ['contentId'], to: 'mediaId' },
            { from: ['contentId'], to: 'showEpisodeId' },
            { from: ['episodeNum'], to: 'showEpisodeNumber' },
            { from: ['fullEpisode'], to: 'episodeFlag' },
            { from: ['genre'], to: 'showGenre' },
            { from: ['isLive'], to: 'isLive' },
            { from: ['label'], to: 'episodeTitle' },
            { from: ['label', 'title'], to: 'showEpisodeTitle' },
            { from: ['mediaType'], to: 'mediaContentType', override: mediaContentTypeOverride(apiMetadata) },
            { from: ['seasonNum'], to: 'showSeasonNumber' },
            { from: ['seriesTitle'], to: 'showSeriesTitle' },
            { from: ['status'], to: 'packageStatus' },
            { from: ['subscriptionLevel'], to: 'mediaSvodContentType' },
            { from: ['title'], to: 'videoTitle' }
        ];
        apiMetadata = utils.DeepMerge.deepmerge({}, apiMetadata);
        if (utils.Type.isString(apiMetadata?.seriesTitle) && apiMetadata.mediaType === MPXMediaType.MOVIE) {
            apiToContextMap.push({ from: ['genre'], to: 'movieGenre' });
            apiToContextMap.push({ from: ['contentId'], to: 'movieId' });
            apiToContextMap.push({ from: ['title'], to: 'movieTitle' });
        }
        contextMetadata.mediaResume = (utils.Type.isNumber(paramsVO?.CONTENT?.globalResumeTime)
            &&
                paramsVO?.CONTENT?.globalResumeTime > 0
            ?
                'true'
            :
                'false');
        contextMetadata = utils.Object.mapMerge(apiMetadata, contextMetadata, apiToContextMap);
        Object.keys(apiMetadata).forEach((key) => {
            if (!utils.Type.isArray(apiMetadata[key])) {
                contextMetadata[key] = apiMetadata[key];
            }
        });
        const utagDataToContextMap = [
            { from: ['brandPlatformId'], to: 'brandPlatformId' },
            { from: ['cm.ssf'], to: 'cm.ssf' },
            { from: ['deviceType'], to: 'deviceType' },
            { from: ['packageSource'], to: 'packageSource' },
            {
                from: ['pageType'], to: 'pageType', default: 'article', override: 'article'
            },
            { from: ['pageUrl', '_pageUrl', 'url'], to: 'pageUrl' },
            { from: ['pageViewGuid'], to: 'pageViewGuid' },
            { from: ['posColNum'], to: 'posColNum' },
            { from: ['posRowNum'], to: 'posRowNum' },
            { from: ['rowHeaderTitle'], to: 'rowHeaderTitle' },
            { from: ['siteEdition'], to: 'siteEdition' },
            { from: ['userProfileCategory'], to: 'userProfileCategory' },
            { from: ['userProfileId'], to: 'userProfileId' },
            { from: ['userProfileMaster'], to: 'userProfileMaster' },
            { from: ['userProfilePath'], to: 'userProfilePath' },
            { from: ['userProfilePic'], to: 'userProfilePic' },
            { from: ['userRegId'], to: 'userRegId' },
            { from: ['userStatus'], to: 'userStatus' },
            { from: ['userType'], to: 'userType' }
        ];
        contextMetadata = utils.Object.mapMerge(window?.utag_data, contextMetadata, utagDataToContextMap);
        if (!utils.Type.isEmpty(contextMetadata.userRegId)) {
            contextMetadata.userRegId = 'anon';
        }
        resolve({ msg: 'Context metadata ready!', contextMetadata: contextMetadata });
    });
};
